import React from 'react';
import { motion } from 'framer-motion';
export function UseCases() {
  const cases = [{
    title: 'Prior Authorization',
    tag: 'Payer workflow',
    desc: 'Automate clinical questionnaires and submissions to insurers.'
  }, {
    title: 'Eligibility Verification',
    tag: 'Payer workflow',
    desc: 'Real-time insurance eligibility checks before patient encounters.'
  }, {
    title: 'Clinical Documentation',
    tag: 'EHR workflow',
    desc: 'Read and write structured notes, summaries, and billing codes.'
  }];
  return <section id="use-cases" className="py-24 relative z-10" data-id="element-127">
      <div className="max-w-7xl mx-auto px-6" data-id="element-128">
        <div className="mb-16" data-id="element-129">
          <span className="text-hubble-accent text-[12px] md:text-[14px] font-body font-medium tracking-[3px] uppercase mb-4 block" data-id="element-130">
            USE CASES
          </span>
          <h2 className="font-heading text-4xl md:text-5xl font-normal tracking-[-1px] text-hubble-text" data-id="element-131">
            Where agents use Hubble.
          </h2>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-132">
          {cases.map((item, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: index * 0.1
        }} className="bg-hubble-card border border-hubble-border rounded-2xl p-8 hover:border-hubble-primary/50 transition-colors" data-id="element-133">
              <div className="inline-block px-3 py-1 rounded-full bg-hubble-primary/10 border border-hubble-primary/20 text-hubble-primary font-body text-xs font-medium mb-6" data-id="element-134">
                {item.tag}
              </div>
              <h3 className="font-heading text-2xl font-medium text-hubble-text mb-4" data-id="element-135">
                {item.title}
              </h3>
              <p className="font-body text-[16px] text-hubble-body leading-[1.6]" data-id="element-136">
                {item.desc}
              </p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}